import { AIWriter } from '@ui/components'

export default function NotFound() {
	return (
		<div className='flex flex-col items-center justify-center h-screen m-auto max-w-lg text-center p-8'>
			<AIWriter delay={ 100 }>
				<div className='text-4xl font-bold'>This page was not found 🧐</div>
				<div className='text-xl mt-4'>We couldn&apos;t find this page in our brains. Please check that you have access and try again.</div>
			</AIWriter>
		</div>
	)
}
